import { Directive, ElementRef, Input, OnDestroy, OnInit, forwardRef, NgZone } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare var $: any;

@Directive({
  selector: '[appSummernote]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SummernoteDirective),
      multi: true
    }
  ]
})
export class SummernoteDirective implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() set height(value: number) {
    this._height = value;
    if (this.isInitialized) {
      $(this.el.nativeElement).summernote('height', value);
    }
  }
  private _height = 200;

  @Input() placeholder = '';

  private isInitialized = false;
  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      $(this.el.nativeElement).summernote({
        height: this._height,
        placeholder: this.placeholder,
        toolbar: [
          ['style', ['style']],
          ['font', ['bold', 'italic', 'underline']],
          ['view', ['fullscreen']]
        ],
        styleTags: ['p', 'h1', 'h2', 'h3'],
        callbacks: {
          onChange: (contents: string) => {
            this.ngZone.run(() => {
              this.onChange(contents);
            });
          },
          onBlur: () => {
            this.ngZone.run(() => {
              this.onTouched();
            });
          },
          onFullScreen: (isFullScreen: boolean) => {
            if (!isFullScreen) {
              // When exiting fullscreen, ensure the original height is restored
              $(this.el.nativeElement).summernote('height', this._height);
            }
          }
        }
      });
      
      this.isInitialized = true;

      if (this.initialValue !== null) {
        $(this.el.nativeElement).summernote('code', this.initialValue);
      }
    });
  }


  ngOnDestroy() {
    if (this.isInitialized) {
      $(this.el.nativeElement).summernote('destroy');
    }
  }

  writeValue(value: any) {
    const code = value || '';
    if (this.isInitialized) {
      if ($(this.el.nativeElement).summernote('code') !== code) {
        $(this.el.nativeElement).summernote('code', code);
      }
    } else {
      // If not initialized yet, we can't set the code. 
      // The ngOnInit will handle the initial creation, 
      // but we need to ensure the initial value is preserved if writeValue is called before ngOnInit.
      this.initialValue = code;
    }
  }

  private initialValue: string | null = null;


  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.isInitialized) {
      if (isDisabled) {
        $(this.el.nativeElement).summernote('disable');
      } else {
        $(this.el.nativeElement).summernote('enable');
      }
    }
  }
}
